import { AccountController } from "@/app/core/base/controllers/AccountController";
import Field from "@/app/core/layouts/main-components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { Message } from "@/app/core/util/messages/GeralMessages";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SignIn(props) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

    function recoverPassword(){
        if(!email){
            toast.error(Message.PendingData);
        }else{
            AccountController.ResetPassword(email);
            toast.success("Foi enviado um email de recuperação de senha para você");
    
            setTimeout(()=>{
                window.location = "#/";
            },15000)
        }
    }

  return (
    <div id="page-container">
      <main id="main-container">
        <div>
          <div className="row no-gutters bg-primary-op">
            <div className="hero-static col-md-6 d-flex align-items-center bg-white">
              <div className="p-3 w-100">
                <div className="mb-3 text-center">
                  <a
                    className="link-fx font-w700 font-size-h1 text-warning"
                    href="javascript:void()"
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/assets/media/logo.png"}
                      style={{ maxWidth: "200px" }} />
                  </a>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-sm-8 col-xl-8">
                        <Field 
                            type={FieldTypeObj.Text}
                            onChange={evt => setEmail(evt.target.value)}
                            title={"Email"}
                            placeholder={"user@email.com"}
                        />

                        <button className="btn btn-block btn-warning text-dark" onClick={()=> recoverPassword()}>Recuperar a senha</button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-image"
              style={{
                backgroundImage: "url('assets/media/photos/bg-intro.jpg')",
              }}
            >
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  Recuperar senha
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Reclame Rio &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                    -Desenvolvido pela{" "}
                    <a
                      className="text-white"
                      href="https://navigate.one"
                      target="_blank" rel="noreferrer"
                    >
                      Navigate
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer className="toastr" />
    </div>
  );
}
